import {
  NEWS_LETTER_EMAIL_LOADING,
  NEWS_LETTER_EMAIL_SUCCESS,
  NEWS_LETTER_EMAIL_FAILURE,
} from "redux/types";

const initialState = {
  newsEmailLoading: false,
  newsEmail: null,
  errors: null,
};

export const newsLetterReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case NEWS_LETTER_EMAIL_LOADING:
      return { ...state, newsEmailLoading: action.payload };
    case NEWS_LETTER_EMAIL_SUCCESS:
      return { ...state, newsEmail: action.payload };
    case NEWS_LETTER_EMAIL_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
